import React, { useEffect } from 'react'
import _ from 'lodash'
import { compose } from 'recompose'
import { Spin } from 'antd'
import { inject } from 'mobx-react'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'

const GET_SETTINGS = gql`
    query barangaySettingsByCode(
		$barangay_uid: String,
		$code: String
	) {
		barangaySettingsByCode(
			barangay_uid: $barangay_uid,
			code: $code
		)
    }
`

const BarangayName = (props) => {
	const { 
		AuthStore, ...rest 
	} = props
	const { barangay_uid=null } = AuthStore
	// const [isSaving, setSaving] = useState(false)

	const handleHeadingAnimation = () => {
		var textWrapper = document.querySelector('.ml1 .letters')
		textWrapper.innerHTML = textWrapper.textContent.replace(/\S/g, '<span class=\'letter\'>$&</span>')

		window.anime.timeline({ loop: true })
			.add({
				targets: '.ml1 .letter',
				scale: [0.3,1],
				opacity: [0,1],
				translateZ: 0,
				easing: 'easeOutExpo',
				duration: 600,
				delay: (el, i) => 70 * (i+1)
			}).add({
				targets: '.ml1 .line',
				scaleX: [0,1],
				opacity: [0.5,1],
				easing: 'easeOutExpo',
				duration: 700,
				offset: '-=875',
				delay: (el, i, l) => 80 * (l - i)
			}).add({
				targets: '.ml1',
				opacity: 0,
				duration: 3000,
				easing: 'easeOutExpo',
				delay: 2000
			})
	}

	useEffect(() => {
		setTimeout(() => {
			handleHeadingAnimation()
		}, 1000)
	},[])

	return (
		<Query query={GET_SETTINGS} variables={{ barangay_uid, code: 'BRGY_NAME' }}>
			{({ loading, error, data }) => {
				if (loading) return <Spin/>
				const mSetting = _.has(data, 'barangaySettingsByCode') ? data.barangaySettingsByCode : {}
				const brgyName = _.has(mSetting, 'value') ? mSetting.value : null
				//return <span { ...rest }>{brgyName}</span>
				
				return (
					<h1 className="ml1">
						<span className="text-wrapper">
							<span className="line line1"></span>
							<span className="letters">Barangay {brgyName} Management System</span>
							<span className="line line2"></span>
						</span>
					</h1>
				)
			}}
		</Query>
	)
}

const composed = compose(
	inject('AuthStore')
)

export default composed(BarangayName)